<template>
  <div>
    <b-form id="login" @submit.prevent="send" v-bind:class="cssClass" autocomplete="off">
      <b-form-group label-for="token" label="Bitte tragen Sie hier den Code zur Bestätigung ein:">
        <b-form-input type="text" id="token" name="token" v-model="token" autofocus autocomplete="off"/>
      </b-form-group>
      <b-button type="submit" variant="primary" class="float-right">Bestätigen</b-button>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'emailConfirmation',

  data: function () {
    return {
      token: '',
      cssClass: 'visible'
    }
  },

  mounted: function () {
    this.token = this.$route.query.token
    if (!this.token) {
      this.cssClass = 'visible'
      return
    }

    this.send()
  },

  methods: {
    send: function () {
      let body = {token: this.token}
      this.axios.post('/registration/confirm', body)
        .then(rsp => {
          this.$eventHub.$emit('auth', rsp, 'registration', 'teacher.dashboard')
        })
        .catch(err => {
          this.$eventHub.$emit('alertError', err)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/guests/Confirmation.vue